import { notification } from 'antd';

const notifications = {

  push: (notificationObj) => {

    if (typeof notificationObj !== "object") {
      throw new Error("Only object can be added to the notifications collection");
    }

    if (!notificationObj.type || !notificationObj.description) return;
    
    if (notificationObj.type === 'error') {
      notificationObj.timeout = 0; // errors have to be cleared manually by the user
    }

    switch(notificationObj.type) {

      default:
        notification[notificationObj.type]({
          message: notificationObj.message,
          description: notificationObj.description,
          duration: notificationObj.timeout ?? 5 //seconds
        });
        break;
    }
  }
};

export default notifications;